// Valida el rut con su cadena completa "XXXXXXXX-X"
export function validaRUT(rutCompleto) {
    if (!rutCompleto) return false;
    rutCompleto = String(rutCompleto)
        .replace(/\./g, '')
        .replace(/\s/g, '')
        .replace('‐', '-')
        .toUpperCase();
    if (!/^[0-9]+[-]{1}[0-9K]{1}$/.test(rutCompleto))
        return false;
    var tmp = rutCompleto.split('-');
    var digv = tmp[1];
    var rut = tmp[0];

    return (dv(rut) == (digv === 'K' ? 'k' : digv));

    function dv(T) {
        var M = 0,
            S = 1;
        for (; T; T = Math.floor(T / 10))
            S = (S + T % 10 * (9 - M++ % 6)) % 11;
        return S ? S - 1 : 'k';
    }
}